/**
 * Created by valerasiestov on 27.11.15.
 */

if (!window.module) {
    window.module = {};
}

module.map = (function (global) {
    "use strict";

    var controls = {},
        handlers = {
            showMapPopup: function (url, address, text) {
                console.log(url, address, text);
                module.popup.show({
                    url: url,
                    beforeShow: function (popup) {
                        document.body.classList.add('popup-scroll-fix');
                    },
                    afterClose: function () {
                        document.body.classList.remove('popup-scroll-fix');
                    },
                    handlers: {
                        popupClose: function (event) {

                            if (window.map && map.destroy) {
                                window.map.destroy();
                            }

                            event.preventDefault();
                            document.body.classList.remove('popup-callback-visible');
                            this.hide();
                        },
                        popupWindowClick: function (event) {
                            event.stopPropagation();
                        }
                    }
                }).then(function (data) {
                    var point = ymaps.geocode(address),
                        header;

                    header = data.dom.querySelector('h2');

                    header.innerHTML = text;

                    point.then(function (res) {
                        var coords = res.geoObjects.get(0).geometry.getCoordinates(),
                            map = window.map = new ymaps.Map('popup-map', {
                                center: [coords[0], coords[1]],
                                zoom: 13
                            }),
                            mark = new ymaps.Placemark([coords[0], coords[1]]);

                        map.geoObjects.add(mark);
                    });
                });
            },

            showMap: function (event) {
                var element = event.target,
                    address = element.getAttribute('data-address'),
                    h3 = element.parentNode.querySelector('h3').innerHTML;

                handlers.showMapPopup(element.getAttribute('data-popup'), address, h3);

            }
        };

    function setEventList() {
        global.addEvents(controls.buttons, 'click', handlers.showMap);
    }

    function getControls() {
        controls.buttons = document.querySelectorAll('.contacts__map-button');
        ymaps.ready(function () {
            // В функцию поступает пространство имен, которое содержит все запрощенные при инициализации модули.
            var myMap = new ymaps.Map('map', {
                    center: [55.6693,37.5538],
                    zoom: 13,
                    // В данном примере карта создается без контролов, так как те не были загружены при инициализации API.
                    controls: []

                }),
                placemark = new ymaps.Placemark([55.6531,37.5540]);

            myMap.behaviors.disable('scrollZoom');
            myMap.geoObjects.add(placemark);

        });
    }

    function init(params) {
        getControls();
        setEventList();
    }

    return {
        init: init
    };

}(DALGAKIRAN.global));

window.addEventListener('DOMContentLoaded', function () {

    if (document.getElementById('map')) {
        module.map.init({

        });
    }

}, false);
